/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One option of a reference param's picker.
 * @export
 * @interface ParamChoiceSchema
 */
export interface ParamChoiceSchema {
    /**
     * 
     * @type {string}
     * @memberof ParamChoiceSchema
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof ParamChoiceSchema
     */
    label: string;
}

/**
 * Check if a given object implements the ParamChoiceSchema interface.
 */
export function instanceOfParamChoiceSchema(value: object): value is ParamChoiceSchema {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function ParamChoiceSchemaFromJSON(json: any): ParamChoiceSchema {
    return ParamChoiceSchemaFromJSONTyped(json, false);
}

export function ParamChoiceSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParamChoiceSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
    };
}

export function ParamChoiceSchemaToJSON(json: any): ParamChoiceSchema {
    return ParamChoiceSchemaToJSONTyped(json, false);
}

export function ParamChoiceSchemaToJSONTyped(value?: ParamChoiceSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
    };
}

